export default __webpack_public_path__ + "static/media/honeySupers.c1a98dcb.jpg";